import { render } from "./AccountViewBase.vue?vue&type=template&id=50a55084"
import script from "./AccountViewBase.vue?vue&type=script&lang=js"
export * from "./AccountViewBase.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__